{
  "abi": [
    {
      "inputs": [
        {
          "internalType": "contract IWorld",
          "name": "_world",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_components",
          "type": "address"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "previousOwner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "OwnershipTransferred",
      "type": "event"
    },
    {
      "inputs": [
        {
          "internalType": "bytes",
          "name": "arguments",
          "type": "bytes"
        }
      ],
      "name": "execute",
      "outputs": [
        {
          "internalType": "bytes",
          "name": "",
          "type": "bytes"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "componentId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "entity",
          "type": "uint256"
        },
        {
          "internalType": "bytes",
          "name": "value",
          "type": "bytes"
        }
      ],
      "name": "executeTyped",
      "outputs": [
        {
          "internalType": "bytes",
          "name": "",
          "type": "bytes"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "owner",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes",
          "name": "",
          "type": "bytes"
        }
      ],
      "name": "requirement",
      "outputs": [
        {
          "internalType": "bytes",
          "name": "",
          "type": "bytes"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "transferOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ],
  "bytecode": {
    "object": "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",
    "sourceMap": "408:981:77:-:0;;;450:78;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;512:6:7;:19;;-1:-1:-1;;;;;;512:19:7;521:10;512:19;;;505:6:77;513:11;-1:-1:-1;;;;;550:25:7;;;:80;;618:11;550:80;;;578:6;-1:-1:-1;;;;;578:17:7;;:19;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;537:10;:93;;-1:-1:-1;;;;;537:93:7;;;-1:-1:-1;;;;;;537:93:7;;;;;;;;636:14;;;;;;;;;;;;;;;-1:-1:-1;408:981:77;;-1:-1:-1;;408:981:77;14:139:101;-1:-1:-1;;;;;97:31:101;;87:42;;77:70;;143:1;140;133:12;77:70;14:139;:::o;158:416::-;252:6;260;313:2;301:9;292:7;288:23;284:32;281:52;;;329:1;326;319:12;281:52;361:9;355:16;380:39;413:5;380:39;:::i;:::-;488:2;473:18;;467:25;438:5;;-1:-1:-1;501:41:101;467:25;501:41;:::i;:::-;561:7;551:17;;;158:416;;;;;:::o;579:285::-;675:6;728:2;716:9;707:7;703:23;699:32;696:52;;;744:1;741;734:12;696:52;776:9;770:16;795:39;828:5;795:39;:::i;:::-;853:5;579:285;-1:-1:-1;;;579:285:101:o;:::-;408:981:77;;;;;;",
    "linkReferences": {}
  },
  "deployedBytecode": {
    "object": "0x608060405234801561001057600080fd5b50600436106100675760003560e01c80638b246a5b116100505780638b246a5b146100a85780638da5cb5b146100bc578063f2fde38b146100e457600080fd5b806309c5eabe1461006c57806334830fd714610095575b600080fd5b61007f61007a36600461068b565b6100f9565b60405161008c919061073a565b60405180910390f35b61007f6100a3366004610754565b6102e8565b61007f6100b636600461068b565b50606090565b60025460405173ffffffffffffffffffffffffffffffffffffffff909116815260200161008c565b6100f76100f23660046107a4565b61031e565b005b60025460609073ffffffffffffffffffffffffffffffffffffffff163314610182576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152600a60248201527f4f4e4c595f4f574e45520000000000000000000000000000000000000000000060448201526064015b60405180910390fd5b60008060008480602001905181019061019b91906107da565b600080549396509194509250906101c89073ffffffffffffffffffffffffffffffffffffffff168561042d565b90508151600003610258576040517f4cc822150000000000000000000000000000000000000000000000000000000081526004810184905273ffffffffffffffffffffffffffffffffffffffff821690634cc8221590602401600060405180830381600087803b15801561023b57600080fd5b505af115801561024f573d6000803e3d6000fd5b505050506102df565b6040517f8b28294700000000000000000000000000000000000000000000000000000000815273ffffffffffffffffffffffffffffffffffffffff821690638b282947906102ac9086908690600401610866565b600060405180830381600087803b1580156102c657600080fd5b505af11580156102da573d6000803e3d6000fd5b505050505b50505050919050565b60606103168484846040516020016103029392919061087f565b6040516020818303038152906040526100f9565b949350505050565b60025473ffffffffffffffffffffffffffffffffffffffff16331461039f576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152600a60248201527f4f4e4c595f4f574e4552000000000000000000000000000000000000000000006044820152606401610179565b60025460405173ffffffffffffffffffffffffffffffffffffffff8084169216907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a3600280547fffffffffffffffffffffffff00000000000000000000000000000000000000001673ffffffffffffffffffffffffffffffffffffffff92909216919091179055565b6040517ffbdfa1ea00000000000000000000000000000000000000000000000000000000815260048101829052600090819073ffffffffffffffffffffffffffffffffffffffff85169063fbdfa1ea90602401600060405180830381865afa15801561049d573d6000803e3d6000fd5b505050506040513d6000823e601f3d9081017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe01682016040526104e391908101906108a7565b90508051600003610550576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601160248201527f6964206e6f7420726567697374657265640000000000000000000000000000006044820152606401610179565b610316816000815181106105665761056661094d565b602002602001015190565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b604051601f82017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe016810167ffffffffffffffff811182821017156105e7576105e7610571565b604052919050565b600067ffffffffffffffff82111561060957610609610571565b50601f017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe01660200190565b600082601f83011261064657600080fd5b8135610659610654826105ef565b6105a0565b81815284602083860101111561066e57600080fd5b816020850160208301376000918101602001919091529392505050565b60006020828403121561069d57600080fd5b813567ffffffffffffffff8111156106b457600080fd5b61031684828501610635565b60005b838110156106db5781810151838201526020016106c3565b838111156106ea576000848401525b50505050565b600081518084526107088160208601602086016106c0565b601f017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0169290920160200192915050565b60208152600061074d60208301846106f0565b9392505050565b60008060006060848603121561076957600080fd5b8335925060208401359150604084013567ffffffffffffffff81111561078e57600080fd5b61079a86828701610635565b9150509250925092565b6000602082840312156107b657600080fd5b813573ffffffffffffffffffffffffffffffffffffffff8116811461074d57600080fd5b6000806000606084860312156107ef57600080fd5b8351925060208401519150604084015167ffffffffffffffff81111561081457600080fd5b8401601f8101861361082557600080fd5b8051610833610654826105ef565b81815287602083850101111561084857600080fd5b6108598260208301602086016106c0565b8093505050509250925092565b82815260406020820152600061031660408301846106f0565b83815282602082015260606040820152600061089e60608301846106f0565b95945050505050565b600060208083850312156108ba57600080fd5b825167ffffffffffffffff808211156108d257600080fd5b818501915085601f8301126108e657600080fd5b8151818111156108f8576108f8610571565b8060051b91506109098483016105a0565b818152918301840191848101908884111561092357600080fd5b938501935b8385101561094157845182529385019390850190610928565b98975050505050505050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603260045260246000fdfea2646970667358221220edf675ccc3f214754f72917115db3f04aade078ed012143fc118104915380dcc64736f6c634300080d0033",
    "sourceMap": "408:981:77:-:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;731:411;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;1146:241;;;;;;:::i;:::-;;:::i;532:195::-;;;;;;:::i;:::-;-1:-1:-1;588:12:77;;532:195;659:80:7;728:6;;659:80;;728:6;;;;2997:74:101;;2985:2;2970:18;659:80:7;2851:226:101;743:148:7;;;;;;:::i;:::-;;:::i;:::-;;731:411:77;830:6;;788:12;;830:6;;816:10;:20;808:43;;;;;;;3598:2:101;808:43:77;;;3580:21:101;3637:2;3617:18;;;3610:30;3676:12;3656:18;;;3649:40;3706:18;;808:43:77;;;;;;;;;858:19;879:14;895:18;928:9;917:48;;;;;;;;;;;;:::i;:::-;971:12;1012:10;;857:108;;-1:-1:-1;857:108:77;;-1:-1:-1;857:108:77;-1:-1:-1;971:12:77;997:39;;1012:10;;857:108;997:14;:39::i;:::-;971:66;;1047:5;:12;1063:1;1047:17;1043:95;;1074:16;;;;;;;;4642:25:101;;;1074:8:77;;;;;;4615:18:101;;1074:16:77;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1043:95;;;1111:20;;;;;:5;;;;;;:20;;1117:6;;1125:5;;1111:20;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1043:95;802:340;;;;731:411;;;:::o;1146:241::-;1308:12;1335:47;1354:11;1367:6;1375:5;1343:38;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;1335:7;:47::i;:::-;1328:54;1146:241;-1:-1:-1;;;;1146:241:77:o;743:148:7:-;421:6;;;;407:10;:20;399:43;;;;;;;3598:2:101;399:43:7;;;3580:21:101;3637:2;3617:18;;;3610:30;3676:12;3656:18;;;3649:40;3706:18;;399:43:7;3396:334:101;399:43:7;846:6:::1;::::0;825:38:::1;::::0;::::1;::::0;;::::1;::::0;846:6:::1;::::0;825:38:::1;::::0;846:6:::1;::::0;825:38:::1;869:6;:17:::0;;;::::1;;::::0;;;::::1;::::0;;;::::1;::::0;;743:148::o;741:248:20:-;860:33;;;;;;;;4642:25:101;;;819:7:20;;;;860:29;;;;;;4615:18:101;;860:33:20;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;832:61;;905:8;:15;924:1;905:20;897:50;;;;;;;6478:2:101;897:50:20;;;6460:21:101;6517:2;6497:18;;;6490:30;6556:19;6536:18;;;6529:47;6593:18;;897:50:20;6276:341:101;897:50:20;958:28;974:8;983:1;974:11;;;;;;;;:::i;:::-;;;;;;;452:6;361:102;14:184:101;66:77;63:1;56:88;163:4;160:1;153:15;187:4;184:1;177:15;203:334;274:2;268:9;330:2;320:13;;335:66;316:86;304:99;;433:18;418:34;;454:22;;;415:62;412:88;;;480:18;;:::i;:::-;516:2;509:22;203:334;;-1:-1:-1;203:334:101:o;542:245::-;590:4;623:18;615:6;612:30;609:56;;;645:18;;:::i;:::-;-1:-1:-1;702:2:101;690:15;707:66;686:88;776:4;682:99;;542:245::o;792:462::-;834:5;887:3;880:4;872:6;868:17;864:27;854:55;;905:1;902;895:12;854:55;941:6;928:20;972:48;988:31;1016:2;988:31;:::i;:::-;972:48;:::i;:::-;1045:2;1036:7;1029:19;1091:3;1084:4;1079:2;1071:6;1067:15;1063:26;1060:35;1057:55;;;1108:1;1105;1098:12;1057:55;1173:2;1166:4;1158:6;1154:17;1147:4;1138:7;1134:18;1121:55;1221:1;1196:16;;;1214:4;1192:27;1185:38;;;;1200:7;792:462;-1:-1:-1;;;792:462:101:o;1259:320::-;1327:6;1380:2;1368:9;1359:7;1355:23;1351:32;1348:52;;;1396:1;1393;1386:12;1348:52;1436:9;1423:23;1469:18;1461:6;1458:30;1455:50;;;1501:1;1498;1491:12;1455:50;1524:49;1565:7;1556:6;1545:9;1541:22;1524:49;:::i;1584:258::-;1656:1;1666:113;1680:6;1677:1;1674:13;1666:113;;;1756:11;;;1750:18;1737:11;;;1730:39;1702:2;1695:10;1666:113;;;1797:6;1794:1;1791:13;1788:48;;;1832:1;1823:6;1818:3;1814:16;1807:27;1788:48;;1584:258;;;:::o;1847:316::-;1888:3;1926:5;1920:12;1953:6;1948:3;1941:19;1969:63;2025:6;2018:4;2013:3;2009:14;2002:4;1995:5;1991:16;1969:63;:::i;:::-;2077:2;2065:15;2082:66;2061:88;2052:98;;;;2152:4;2048:109;;1847:316;-1:-1:-1;;1847:316:101:o;2168:217::-;2315:2;2304:9;2297:21;2278:4;2335:44;2375:2;2364:9;2360:18;2352:6;2335:44;:::i;:::-;2327:52;2168:217;-1:-1:-1;;;2168:217:101:o;2390:456::-;2476:6;2484;2492;2545:2;2533:9;2524:7;2520:23;2516:32;2513:52;;;2561:1;2558;2551:12;2513:52;2597:9;2584:23;2574:33;;2654:2;2643:9;2639:18;2626:32;2616:42;;2709:2;2698:9;2694:18;2681:32;2736:18;2728:6;2725:30;2722:50;;;2768:1;2765;2758:12;2722:50;2791:49;2832:7;2823:6;2812:9;2808:22;2791:49;:::i;:::-;2781:59;;;2390:456;;;;;:::o;3082:309::-;3141:6;3194:2;3182:9;3173:7;3169:23;3165:32;3162:52;;;3210:1;3207;3200:12;3162:52;3249:9;3236:23;3299:42;3292:5;3288:54;3281:5;3278:65;3268:93;;3357:1;3354;3347:12;3735:756;3832:6;3840;3848;3901:2;3889:9;3880:7;3876:23;3872:32;3869:52;;;3917:1;3914;3907:12;3869:52;3946:9;3940:16;3930:26;;3996:2;3985:9;3981:18;3975:25;3965:35;;4044:2;4033:9;4029:18;4023:25;4071:18;4063:6;4060:30;4057:50;;;4103:1;4100;4093:12;4057:50;4126:22;;4179:4;4171:13;;4167:27;-1:-1:-1;4157:55:101;;4208:1;4205;4198:12;4157:55;4237:2;4231:9;4262:48;4278:31;4306:2;4278:31;:::i;4262:48::-;4333:2;4326:5;4319:17;4373:7;4368:2;4363;4359;4355:11;4351:20;4348:33;4345:53;;;4394:1;4391;4384:12;4345:53;4407:54;4458:2;4453;4446:5;4442:14;4437:2;4433;4429:11;4407:54;:::i;:::-;4480:5;4470:15;;;;;3735:756;;;;;:::o;4678:288::-;4853:6;4842:9;4835:25;4896:2;4891;4880:9;4876:18;4869:30;4816:4;4916:44;4956:2;4945:9;4941:18;4933:6;4916:44;:::i;4971:359::-;5174:6;5163:9;5156:25;5217:6;5212:2;5201:9;5197:18;5190:34;5260:2;5255;5244:9;5240:18;5233:30;5137:4;5280:44;5320:2;5309:9;5305:18;5297:6;5280:44;:::i;:::-;5272:52;4971:359;-1:-1:-1;;;;;4971:359:101:o;5335:936::-;5430:6;5461:2;5504;5492:9;5483:7;5479:23;5475:32;5472:52;;;5520:1;5517;5510:12;5472:52;5553:9;5547:16;5582:18;5623:2;5615:6;5612:14;5609:34;;;5639:1;5636;5629:12;5609:34;5677:6;5666:9;5662:22;5652:32;;5722:7;5715:4;5711:2;5707:13;5703:27;5693:55;;5744:1;5741;5734:12;5693:55;5773:2;5767:9;5795:2;5791;5788:10;5785:36;;;5801:18;;:::i;:::-;5847:2;5844:1;5840:10;5830:20;;5870:28;5894:2;5890;5886:11;5870:28;:::i;:::-;5932:15;;;6002:11;;;5998:20;;;5963:12;;;;6030:19;;;6027:39;;;6062:1;6059;6052:12;6027:39;6086:11;;;;6106:135;6122:6;6117:3;6114:15;6106:135;;;6188:10;;6176:23;;6139:12;;;;6219;;;;6106:135;;;6260:5;5335:936;-1:-1:-1;;;;;;;;5335:936:101:o;6622:184::-;6674:77;6671:1;6664:88;6771:4;6768:1;6761:15;6795:4;6792:1;6785:15",
    "linkReferences": {}
  },
  "methodIdentifiers": {
    "execute(bytes)": "09c5eabe",
    "executeTyped(uint256,uint256,bytes)": "34830fd7",
    "owner()": "8da5cb5b",
    "requirement(bytes)": "8b246a5b",
    "transferOwnership(address)": "f2fde38b"
  },
  "rawMetadata": "{\"compiler\":{\"version\":\"0.8.13+commit.abaa5c0e\"},\"language\":\"Solidity\",\"output\":{\"abi\":[{\"inputs\":[{\"internalType\":\"contract IWorld\",\"name\":\"_world\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"_components\",\"type\":\"address\"}],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"previousOwner\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"newOwner\",\"type\":\"address\"}],\"name\":\"OwnershipTransferred\",\"type\":\"event\"},{\"inputs\":[{\"internalType\":\"bytes\",\"name\":\"arguments\",\"type\":\"bytes\"}],\"name\":\"execute\",\"outputs\":[{\"internalType\":\"bytes\",\"name\":\"\",\"type\":\"bytes\"}],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"componentId\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"entity\",\"type\":\"uint256\"},{\"internalType\":\"bytes\",\"name\":\"value\",\"type\":\"bytes\"}],\"name\":\"executeTyped\",\"outputs\":[{\"internalType\":\"bytes\",\"name\":\"\",\"type\":\"bytes\"}],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"owner\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"bytes\",\"name\":\"\",\"type\":\"bytes\"}],\"name\":\"requirement\",\"outputs\":[{\"internalType\":\"bytes\",\"name\":\"\",\"type\":\"bytes\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"newOwner\",\"type\":\"address\"}],\"name\":\"transferOwnership\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"}],\"devdoc\":{\"kind\":\"dev\",\"methods\":{\"owner()\":{\"returns\":{\"_0\":\"The address of the owner.\"}}},\"version\":1},\"userdoc\":{\"kind\":\"user\",\"methods\":{\"owner()\":{\"notice\":\"Get the address of the owner\"}},\"version\":1}},\"settings\":{\"compilationTarget\":{\"src/systems/ComponentDevSystem.sol\":\"ComponentDevSystem\"},\"evmVersion\":\"london\",\"libraries\":{},\"metadata\":{\"bytecodeHash\":\"ipfs\"},\"optimizer\":{\"enabled\":true,\"runs\":1000000},\"remappings\":[\":@latticexyz/=../../node_modules/@latticexyz/\",\":@manifoldxyz/=../../node_modules/@manifoldxyz/\",\":@opengsn/=../../node_modules/@opengsn/\",\":@openzeppelin/=../../node_modules/openzeppelin-solidity/\",\":@rari-capital/=../../node_modules/@rari-capital/\",\":abdk-libraries-solidity/=../../node_modules/abdk-libraries-solidity/\",\":base64-sol/=../../node_modules/base64-sol/\",\":base64/=../../node_modules/base64-sol/\",\":components/=src/components/\",\":ds-test/=../../node_modules/ds-test/src/\",\":forge-std/=../../node_modules/forge-std/src/\",\":gsn/=../../node_modules/@opengsn/contracts/src/\",\":hardhat-deploy/=../../node_modules/hardhat-deploy/\",\":hardhat/=../../node_modules/hardhat/\",\":libraries/=src/libraries/\",\":memmove/=../../node_modules/memmove/src/\",\":noise/=../../node_modules/@latticexyz/noise/contracts/\",\":openzeppelin-solidity/=../../node_modules/openzeppelin-solidity/\",\":persona/=../../node_modules/@latticexyz/persona/src/\",\":royalty-registry/=../../node_modules/@manifoldxyz/royalty-registry-solidity/contracts/\",\":solecs/=../../node_modules/@latticexyz/solecs/src/\",\":solmate/=../../node_modules/@rari-capital/solmate/src/\",\":std-contracts/=../../node_modules/@latticexyz/std-contracts/src/\",\":systems/=src/systems/\"]},\"sources\":{\"../../node_modules/@latticexyz/solecs/src/LibTypes.sol\":{\"keccak256\":\"0xa3898035fd9fa865bcfc9861e3b5ecce36be3196fb27705e50a02fed9831f102\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://273284a35a950f6d0bc4223d345cf46c59972a00510ddbc4ba695ede38714798\",\"dweb:/ipfs/QmdqzKMaAfKWfBzUsrzsDMWnyxSKJRuEvrc6VTR5VarQaH\"]},\"../../node_modules/@latticexyz/solecs/src/System.sol\":{\"keccak256\":\"0x5ff430169885d31cb4d41ccf5ba8ac1f0815d3bb1b9dc9afcf9afd6a7203e7c7\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://59892068a9b62d8c01d272ea5de2e8f2932a7ea87acce9b6eaccfae00dad8e66\",\"dweb:/ipfs/QmfEdTjYkdHfueS527ibx3Ni8X3yqgQHtbRB1anDTsMGBN\"]},\"../../node_modules/@latticexyz/solecs/src/constants.sol\":{\"keccak256\":\"0x024a3ff3077a272339b7baa96b826fd75f040d7cd2c6e13b9c8cf7ad16f789b8\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://1ddcb26a7703e9b03b34d5465010a4ae5ced137021c94987053544ad1156a644\",\"dweb:/ipfs/QmYue4gnb8noyoxxTchs5chZji7DKynKMp2x33RgRW6xqZ\"]},\"../../node_modules/@latticexyz/solecs/src/interfaces/IComponent.sol\":{\"keccak256\":\"0x4513448bb0d45050f8af0a2ead426b27a5d5ca73d38c6874e909f852ad2232e6\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://e5c215b87500c80ffb525142b753a4f3454a69cf11b9b68f6a29f1a4dd4a2ced\",\"dweb:/ipfs/Qmd4YYoYJTrgyQU8zcfJFDdYQA29DarkdL8k5obyGgbp2K\"]},\"../../node_modules/@latticexyz/solecs/src/interfaces/IERC173.sol\":{\"keccak256\":\"0xc8fa875a59c2010265d7fc5663d9d37e6b5f9b556b6bfdeeb7ec9355ee3169c7\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://33d944c6ff71c7afe4d21db8f4077e419f165100bbfd8b6c8d4b975015ec6c82\",\"dweb:/ipfs/QmY461W1TtyjkkcUuxPHUtJ3LxzD1iaU422FkFhtHHuRQh\"]},\"../../node_modules/@latticexyz/solecs/src/interfaces/ISystem.sol\":{\"keccak256\":\"0x62af78f49b90c7c23ad677e4090c5c916e1c2e36b13be07887b371ba732294c9\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://c8c0849bc60d65a4578a66b8d0052b584e8b43838b78bc2c2579113f625cd05a\",\"dweb:/ipfs/Qma8pxGUAupCkTJYjXeHV9i4qvjnMP9s8zi5rs6FDrDuy7\"]},\"../../node_modules/@latticexyz/solecs/src/interfaces/IUint256Component.sol\":{\"keccak256\":\"0x12e2eaa4c5663048343e43a1994c446baacb16a4aacbe314ed5202d878751be9\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://2d78184a1b1868773f2d5a7cf54bb42bccc666dc75cea14eeed15b8573fd000f\",\"dweb:/ipfs/QmemXPHPB7V8StWR8kZcKt3eDxB78sZFZW4Dp7TcEFTxx9\"]},\"../../node_modules/@latticexyz/solecs/src/interfaces/IWorld.sol\":{\"keccak256\":\"0x319806cf4ed67acdd9f444ac581486e157ea06bceb8e727c6d745c165e0d9aae\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://9b2cb8ec879279c74b384f169595e50fd1850ce63275447748d9150dfa9a85be\",\"dweb:/ipfs/QmNPQBfqVg3iDF2qE8KTJWx1zbpJjnzteNYiqGxtBye2q2\"]},\"../../node_modules/@latticexyz/solecs/src/interfaces/Query.sol\":{\"keccak256\":\"0xd11a3268514fceac97995d481017e49b18835e31ce3540e5f21c24df33e4bc2c\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://841dd95a4f5e89f0451a72544a47eb16be41b8005dadfe98a82054db3eb41ab7\",\"dweb:/ipfs/QmScv2neVyCeoCmMZyRyYcqD5QwauuoWmkixyxw4qftEeR\"]},\"../../node_modules/@latticexyz/solecs/src/utils.sol\":{\"keccak256\":\"0x17f7831c03bdd77f0c7d98c94931d830fbbfa1878c365f54b12841c85611e24e\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://6ae566ee03c5050b239277ef4184b9e5dcb332c8cc65b032f8e0d9e46408ea6d\",\"dweb:/ipfs/QmetdhxahRf7FJk1kn8KgDmizU2zYk3jjt9qo6Gwz2M5YP\"]},\"../../node_modules/memmove/src/Array.sol\":{\"keccak256\":\"0x0d7681d3392c34f811cebc9598c5e8f4eef6aba431dca9e1fa87267ba51a4515\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://0ffb5179dd40ccacadc2cb26ac99e9ea5148796f6d21413d7e0f37913831bea1\",\"dweb:/ipfs/QmfJogaoqook5JgnUZKib6w6khzViUag3EQb1EZ8aUEasQ\"]},\"../../node_modules/memmove/src/LinkedList.sol\":{\"keccak256\":\"0x2374863d39689178dda92b841e77b835ba8fa550561be23b7861d2e52c0fe8c1\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://8538ec6ca6be4e1b25b74dfd2139586fa2b9dab8d49d91428ed64dc683884598\",\"dweb:/ipfs/Qma7Z6urenqG5Dzqwe8ouGiFH37mbsJEX83tqjSq1PTnRc\"]},\"src/systems/ComponentDevSystem.sol\":{\"keccak256\":\"0x5bbab9ca2069d699744c4f177d97a0beb81c538aa45beac4b375acb65e95f409\",\"license\":\"GPL-3.0\",\"urls\":[\"bzz-raw://f4553baefd2ccbf285ac3ebf138fd6281e172cbeb56fbec0541f25c7577eab13\",\"dweb:/ipfs/QmbkSbv1GKboK4ppb8f6Z7pNFKgGvYvvvHWFbb2MHqcrfW\"]}},\"version\":1}",
  "metadata": {
    "compiler": {
      "version": "0.8.13+commit.abaa5c0e"
    },
    "language": "Solidity",
    "output": {
      "abi": [
        {
          "inputs": [
            {
              "internalType": "contract IWorld",
              "name": "_world",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_components",
              "type": "address"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "constructor"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "previousOwner",
              "type": "address",
              "indexed": true
            },
            {
              "internalType": "address",
              "name": "newOwner",
              "type": "address",
              "indexed": true
            }
          ],
          "type": "event",
          "name": "OwnershipTransferred",
          "anonymous": false
        },
        {
          "inputs": [
            {
              "internalType": "bytes",
              "name": "arguments",
              "type": "bytes"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function",
          "name": "execute",
          "outputs": [
            {
              "internalType": "bytes",
              "name": "",
              "type": "bytes"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "componentId",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "entity",
              "type": "uint256"
            },
            {
              "internalType": "bytes",
              "name": "value",
              "type": "bytes"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function",
          "name": "executeTyped",
          "outputs": [
            {
              "internalType": "bytes",
              "name": "",
              "type": "bytes"
            }
          ]
        },
        {
          "inputs": [],
          "stateMutability": "view",
          "type": "function",
          "name": "owner",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "bytes",
              "name": "",
              "type": "bytes"
            }
          ],
          "stateMutability": "view",
          "type": "function",
          "name": "requirement",
          "outputs": [
            {
              "internalType": "bytes",
              "name": "",
              "type": "bytes"
            }
          ]
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "newOwner",
              "type": "address"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function",
          "name": "transferOwnership"
        }
      ],
      "devdoc": {
        "kind": "dev",
        "methods": {
          "owner()": {
            "returns": {
              "_0": "The address of the owner."
            }
          }
        },
        "version": 1
      },
      "userdoc": {
        "kind": "user",
        "methods": {
          "owner()": {
            "notice": "Get the address of the owner"
          }
        },
        "version": 1
      }
    },
    "settings": {
      "remappings": [
        ":@latticexyz/=../../node_modules/@latticexyz/",
        ":@manifoldxyz/=../../node_modules/@manifoldxyz/",
        ":@opengsn/=../../node_modules/@opengsn/",
        ":@openzeppelin/=../../node_modules/openzeppelin-solidity/",
        ":@rari-capital/=../../node_modules/@rari-capital/",
        ":abdk-libraries-solidity/=../../node_modules/abdk-libraries-solidity/",
        ":base64-sol/=../../node_modules/base64-sol/",
        ":base64/=../../node_modules/base64-sol/",
        ":components/=src/components/",
        ":ds-test/=../../node_modules/ds-test/src/",
        ":forge-std/=../../node_modules/forge-std/src/",
        ":gsn/=../../node_modules/@opengsn/contracts/src/",
        ":hardhat-deploy/=../../node_modules/hardhat-deploy/",
        ":hardhat/=../../node_modules/hardhat/",
        ":libraries/=src/libraries/",
        ":memmove/=../../node_modules/memmove/src/",
        ":noise/=../../node_modules/@latticexyz/noise/contracts/",
        ":openzeppelin-solidity/=../../node_modules/openzeppelin-solidity/",
        ":persona/=../../node_modules/@latticexyz/persona/src/",
        ":royalty-registry/=../../node_modules/@manifoldxyz/royalty-registry-solidity/contracts/",
        ":solecs/=../../node_modules/@latticexyz/solecs/src/",
        ":solmate/=../../node_modules/@rari-capital/solmate/src/",
        ":std-contracts/=../../node_modules/@latticexyz/std-contracts/src/",
        ":systems/=src/systems/"
      ],
      "optimizer": {
        "enabled": true,
        "runs": 1000000
      },
      "metadata": {
        "bytecodeHash": "ipfs"
      },
      "compilationTarget": {
        "src/systems/ComponentDevSystem.sol": "ComponentDevSystem"
      },
      "libraries": {}
    },
    "sources": {
      "../../node_modules/@latticexyz/solecs/src/LibTypes.sol": {
        "keccak256": "0xa3898035fd9fa865bcfc9861e3b5ecce36be3196fb27705e50a02fed9831f102",
        "urls": [
          "bzz-raw://273284a35a950f6d0bc4223d345cf46c59972a00510ddbc4ba695ede38714798",
          "dweb:/ipfs/QmdqzKMaAfKWfBzUsrzsDMWnyxSKJRuEvrc6VTR5VarQaH"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/System.sol": {
        "keccak256": "0x5ff430169885d31cb4d41ccf5ba8ac1f0815d3bb1b9dc9afcf9afd6a7203e7c7",
        "urls": [
          "bzz-raw://59892068a9b62d8c01d272ea5de2e8f2932a7ea87acce9b6eaccfae00dad8e66",
          "dweb:/ipfs/QmfEdTjYkdHfueS527ibx3Ni8X3yqgQHtbRB1anDTsMGBN"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/constants.sol": {
        "keccak256": "0x024a3ff3077a272339b7baa96b826fd75f040d7cd2c6e13b9c8cf7ad16f789b8",
        "urls": [
          "bzz-raw://1ddcb26a7703e9b03b34d5465010a4ae5ced137021c94987053544ad1156a644",
          "dweb:/ipfs/QmYue4gnb8noyoxxTchs5chZji7DKynKMp2x33RgRW6xqZ"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/interfaces/IComponent.sol": {
        "keccak256": "0x4513448bb0d45050f8af0a2ead426b27a5d5ca73d38c6874e909f852ad2232e6",
        "urls": [
          "bzz-raw://e5c215b87500c80ffb525142b753a4f3454a69cf11b9b68f6a29f1a4dd4a2ced",
          "dweb:/ipfs/Qmd4YYoYJTrgyQU8zcfJFDdYQA29DarkdL8k5obyGgbp2K"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/interfaces/IERC173.sol": {
        "keccak256": "0xc8fa875a59c2010265d7fc5663d9d37e6b5f9b556b6bfdeeb7ec9355ee3169c7",
        "urls": [
          "bzz-raw://33d944c6ff71c7afe4d21db8f4077e419f165100bbfd8b6c8d4b975015ec6c82",
          "dweb:/ipfs/QmY461W1TtyjkkcUuxPHUtJ3LxzD1iaU422FkFhtHHuRQh"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/interfaces/ISystem.sol": {
        "keccak256": "0x62af78f49b90c7c23ad677e4090c5c916e1c2e36b13be07887b371ba732294c9",
        "urls": [
          "bzz-raw://c8c0849bc60d65a4578a66b8d0052b584e8b43838b78bc2c2579113f625cd05a",
          "dweb:/ipfs/Qma8pxGUAupCkTJYjXeHV9i4qvjnMP9s8zi5rs6FDrDuy7"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/interfaces/IUint256Component.sol": {
        "keccak256": "0x12e2eaa4c5663048343e43a1994c446baacb16a4aacbe314ed5202d878751be9",
        "urls": [
          "bzz-raw://2d78184a1b1868773f2d5a7cf54bb42bccc666dc75cea14eeed15b8573fd000f",
          "dweb:/ipfs/QmemXPHPB7V8StWR8kZcKt3eDxB78sZFZW4Dp7TcEFTxx9"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/interfaces/IWorld.sol": {
        "keccak256": "0x319806cf4ed67acdd9f444ac581486e157ea06bceb8e727c6d745c165e0d9aae",
        "urls": [
          "bzz-raw://9b2cb8ec879279c74b384f169595e50fd1850ce63275447748d9150dfa9a85be",
          "dweb:/ipfs/QmNPQBfqVg3iDF2qE8KTJWx1zbpJjnzteNYiqGxtBye2q2"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/interfaces/Query.sol": {
        "keccak256": "0xd11a3268514fceac97995d481017e49b18835e31ce3540e5f21c24df33e4bc2c",
        "urls": [
          "bzz-raw://841dd95a4f5e89f0451a72544a47eb16be41b8005dadfe98a82054db3eb41ab7",
          "dweb:/ipfs/QmScv2neVyCeoCmMZyRyYcqD5QwauuoWmkixyxw4qftEeR"
        ],
        "license": "MIT"
      },
      "../../node_modules/@latticexyz/solecs/src/utils.sol": {
        "keccak256": "0x17f7831c03bdd77f0c7d98c94931d830fbbfa1878c365f54b12841c85611e24e",
        "urls": [
          "bzz-raw://6ae566ee03c5050b239277ef4184b9e5dcb332c8cc65b032f8e0d9e46408ea6d",
          "dweb:/ipfs/QmetdhxahRf7FJk1kn8KgDmizU2zYk3jjt9qo6Gwz2M5YP"
        ],
        "license": "MIT"
      },
      "../../node_modules/memmove/src/Array.sol": {
        "keccak256": "0x0d7681d3392c34f811cebc9598c5e8f4eef6aba431dca9e1fa87267ba51a4515",
        "urls": [
          "bzz-raw://0ffb5179dd40ccacadc2cb26ac99e9ea5148796f6d21413d7e0f37913831bea1",
          "dweb:/ipfs/QmfJogaoqook5JgnUZKib6w6khzViUag3EQb1EZ8aUEasQ"
        ],
        "license": "MIT"
      },
      "../../node_modules/memmove/src/LinkedList.sol": {
        "keccak256": "0x2374863d39689178dda92b841e77b835ba8fa550561be23b7861d2e52c0fe8c1",
        "urls": [
          "bzz-raw://8538ec6ca6be4e1b25b74dfd2139586fa2b9dab8d49d91428ed64dc683884598",
          "dweb:/ipfs/Qma7Z6urenqG5Dzqwe8ouGiFH37mbsJEX83tqjSq1PTnRc"
        ],
        "license": "MIT"
      },
      "src/systems/ComponentDevSystem.sol": {
        "keccak256": "0x5bbab9ca2069d699744c4f177d97a0beb81c538aa45beac4b375acb65e95f409",
        "urls": [
          "bzz-raw://f4553baefd2ccbf285ac3ebf138fd6281e172cbeb56fbec0541f25c7577eab13",
          "dweb:/ipfs/QmbkSbv1GKboK4ppb8f6Z7pNFKgGvYvvvHWFbb2MHqcrfW"
        ],
        "license": "GPL-3.0"
      }
    },
    "version": 1
  },
  "ast": {
    "absolutePath": "src/systems/ComponentDevSystem.sol",
    "id": 32055,
    "exportedSymbols": {
      "ComponentDevSystem": [
        32054
      ],
      "IComponent": [
        4941
      ],
      "ID": [
        31945
      ],
      "ISystem": [
        4954
      ],
      "IUint256Component": [
        4983
      ],
      "IWorld": [
        5096
      ],
      "System": [
        4204
      ],
      "getAddressById": [
        5176
      ]
    },
    "nodeType": "SourceUnit",
    "src": "36:1354:77",
    "nodes": [
      {
        "id": 31928,
        "nodeType": "PragmaDirective",
        "src": "36:24:77",
        "nodes": [],
        "literals": [
          "solidity",
          ">=",
          "0.8",
          ".0"
        ]
      },
      {
        "id": 31929,
        "nodeType": "ImportDirective",
        "src": "61:27:77",
        "nodes": [],
        "absolutePath": "../../node_modules/@latticexyz/solecs/src/System.sol",
        "file": "solecs/System.sol",
        "nameLocation": "-1:-1:-1",
        "scope": 32055,
        "sourceUnit": 4205,
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "id": 31931,
        "nodeType": "ImportDirective",
        "src": "89:54:77",
        "nodes": [],
        "absolutePath": "../../node_modules/@latticexyz/solecs/src/interfaces/IWorld.sol",
        "file": "solecs/interfaces/IWorld.sol",
        "nameLocation": "-1:-1:-1",
        "scope": 32055,
        "sourceUnit": 5097,
        "symbolAliases": [
          {
            "foreign": {
              "id": 31930,
              "name": "IWorld",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 5096,
              "src": "98:6:77",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          }
        ],
        "unitAlias": ""
      },
      {
        "id": 31933,
        "nodeType": "ImportDirective",
        "src": "144:76:77",
        "nodes": [],
        "absolutePath": "../../node_modules/@latticexyz/solecs/src/interfaces/IUint256Component.sol",
        "file": "solecs/interfaces/IUint256Component.sol",
        "nameLocation": "-1:-1:-1",
        "scope": 32055,
        "sourceUnit": 4984,
        "symbolAliases": [
          {
            "foreign": {
              "id": 31932,
              "name": "IUint256Component",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 4983,
              "src": "153:17:77",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          }
        ],
        "unitAlias": ""
      },
      {
        "id": 31935,
        "nodeType": "ImportDirective",
        "src": "221:62:77",
        "nodes": [],
        "absolutePath": "../../node_modules/@latticexyz/solecs/src/interfaces/IComponent.sol",
        "file": "solecs/interfaces/IComponent.sol",
        "nameLocation": "-1:-1:-1",
        "scope": 32055,
        "sourceUnit": 4942,
        "symbolAliases": [
          {
            "foreign": {
              "id": 31934,
              "name": "IComponent",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 4941,
              "src": "230:10:77",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          }
        ],
        "unitAlias": ""
      },
      {
        "id": 31937,
        "nodeType": "ImportDirective",
        "src": "284:50:77",
        "nodes": [],
        "absolutePath": "../../node_modules/@latticexyz/solecs/src/utils.sol",
        "file": "solecs/utils.sol",
        "nameLocation": "-1:-1:-1",
        "scope": 32055,
        "sourceUnit": 5364,
        "symbolAliases": [
          {
            "foreign": {
              "id": 31936,
              "name": "getAddressById",
              "nodeType": "Identifier",
              "overloadedDeclarations": [],
              "referencedDeclaration": 5176,
              "src": "293:14:77",
              "typeDescriptions": {}
            },
            "nameLocation": "-1:-1:-1"
          }
        ],
        "unitAlias": ""
      },
      {
        "id": 31945,
        "nodeType": "VariableDeclaration",
        "src": "336:69:77",
        "nodes": [],
        "constant": true,
        "mutability": "constant",
        "name": "ID",
        "nameLocation": "353:2:77",
        "scope": 32055,
        "stateVariable": false,
        "storageLocation": "default",
        "typeDescriptions": {
          "typeIdentifier": "t_uint256",
          "typeString": "uint256"
        },
        "typeName": {
          "id": 31938,
          "name": "uint256",
          "nodeType": "ElementaryTypeName",
          "src": "336:7:77",
          "typeDescriptions": {
            "typeIdentifier": "t_uint256",
            "typeString": "uint256"
          }
        },
        "value": {
          "arguments": [
            {
              "arguments": [
                {
                  "hexValue": "656d6265722e73797374656d2e636f6d706f6e656e74446576",
                  "id": 31942,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "string",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "376:27:77",
                  "typeDescriptions": {
                    "typeIdentifier": "t_stringliteral_fb67c350e38cf96cd8e95b5c2d887376d7d9a11609dda5ce343f917d96453e06",
                    "typeString": "literal_string \"ember.system.componentDev\""
                  },
                  "value": "ember.system.componentDev"
                }
              ],
              "expression": {
                "argumentTypes": [
                  {
                    "typeIdentifier": "t_stringliteral_fb67c350e38cf96cd8e95b5c2d887376d7d9a11609dda5ce343f917d96453e06",
                    "typeString": "literal_string \"ember.system.componentDev\""
                  }
                ],
                "id": 31941,
                "name": "keccak256",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": -8,
                "src": "366:9:77",
                "typeDescriptions": {
                  "typeIdentifier": "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
                  "typeString": "function (bytes memory) pure returns (bytes32)"
                }
              },
              "id": 31943,
              "isConstant": false,
              "isLValue": false,
              "isPure": true,
              "kind": "functionCall",
              "lValueRequested": false,
              "names": [],
              "nodeType": "FunctionCall",
              "src": "366:38:77",
              "tryCall": false,
              "typeDescriptions": {
                "typeIdentifier": "t_bytes32",
                "typeString": "bytes32"
              }
            }
          ],
          "expression": {
            "argumentTypes": [
              {
                "typeIdentifier": "t_bytes32",
                "typeString": "bytes32"
              }
            ],
            "id": 31940,
            "isConstant": false,
            "isLValue": false,
            "isPure": true,
            "lValueRequested": false,
            "nodeType": "ElementaryTypeNameExpression",
            "src": "358:7:77",
            "typeDescriptions": {
              "typeIdentifier": "t_type$_t_uint256_$",
              "typeString": "type(uint256)"
            },
            "typeName": {
              "id": 31939,
              "name": "uint256",
              "nodeType": "ElementaryTypeName",
              "src": "358:7:77",
              "typeDescriptions": {}
            }
          },
          "id": 31944,
          "isConstant": false,
          "isLValue": false,
          "isPure": true,
          "kind": "typeConversion",
          "lValueRequested": false,
          "names": [],
          "nodeType": "FunctionCall",
          "src": "358:47:77",
          "tryCall": false,
          "typeDescriptions": {
            "typeIdentifier": "t_uint256",
            "typeString": "uint256"
          }
        },
        "visibility": "internal"
      },
      {
        "id": 32054,
        "nodeType": "ContractDefinition",
        "src": "408:981:77",
        "nodes": [
          {
            "id": 31960,
            "nodeType": "FunctionDefinition",
            "src": "450:78:77",
            "nodes": [],
            "body": {
              "id": 31959,
              "nodeType": "Block",
              "src": "526:2:77",
              "nodes": [],
              "statements": []
            },
            "implemented": true,
            "kind": "constructor",
            "modifiers": [
              {
                "arguments": [
                  {
                    "id": 31955,
                    "name": "_world",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 31950,
                    "src": "505:6:77",
                    "typeDescriptions": {
                      "typeIdentifier": "t_contract$_IWorld_$5096",
                      "typeString": "contract IWorld"
                    }
                  },
                  {
                    "id": 31956,
                    "name": "_components",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 31952,
                    "src": "513:11:77",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  }
                ],
                "id": 31957,
                "kind": "baseConstructorSpecifier",
                "modifierName": {
                  "id": 31954,
                  "name": "System",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 4204,
                  "src": "498:6:77"
                },
                "nodeType": "ModifierInvocation",
                "src": "498:27:77"
              }
            ],
            "name": "",
            "nameLocation": "-1:-1:-1",
            "parameters": {
              "id": 31953,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 31950,
                  "mutability": "mutable",
                  "name": "_world",
                  "nameLocation": "469:6:77",
                  "nodeType": "VariableDeclaration",
                  "scope": 31960,
                  "src": "462:13:77",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_contract$_IWorld_$5096",
                    "typeString": "contract IWorld"
                  },
                  "typeName": {
                    "id": 31949,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 31948,
                      "name": "IWorld",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 5096,
                      "src": "462:6:77"
                    },
                    "referencedDeclaration": 5096,
                    "src": "462:6:77",
                    "typeDescriptions": {
                      "typeIdentifier": "t_contract$_IWorld_$5096",
                      "typeString": "contract IWorld"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 31952,
                  "mutability": "mutable",
                  "name": "_components",
                  "nameLocation": "485:11:77",
                  "nodeType": "VariableDeclaration",
                  "scope": 31960,
                  "src": "477:19:77",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 31951,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "477:7:77",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "461:36:77"
            },
            "returnParameters": {
              "id": 31958,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "526:0:77"
            },
            "scope": 32054,
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 31968,
            "nodeType": "FunctionDefinition",
            "src": "532:195:77",
            "nodes": [],
            "body": {
              "id": 31967,
              "nodeType": "Block",
              "src": "602:125:77",
              "nodes": [],
              "statements": []
            },
            "functionSelector": "8b246a5b",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "requirement",
            "nameLocation": "541:11:77",
            "parameters": {
              "id": 31963,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 31962,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 31968,
                  "src": "553:12:77",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_bytes_memory_ptr",
                    "typeString": "bytes"
                  },
                  "typeName": {
                    "id": 31961,
                    "name": "bytes",
                    "nodeType": "ElementaryTypeName",
                    "src": "553:5:77",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bytes_storage_ptr",
                      "typeString": "bytes"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "552:14:77"
            },
            "returnParameters": {
              "id": 31966,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 31965,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 31968,
                  "src": "588:12:77",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_bytes_memory_ptr",
                    "typeString": "bytes"
                  },
                  "typeName": {
                    "id": 31964,
                    "name": "bytes",
                    "nodeType": "ElementaryTypeName",
                    "src": "588:5:77",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bytes_storage_ptr",
                      "typeString": "bytes"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "587:14:77"
            },
            "scope": 32054,
            "stateMutability": "view",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 32032,
            "nodeType": "FunctionDefinition",
            "src": "731:411:77",
            "nodes": [],
            "body": {
              "id": 32031,
              "nodeType": "Block",
              "src": "802:340:77",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        "id": 31979,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "id": 31976,
                            "name": "msg",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": -15,
                            "src": "816:3:77",
                            "typeDescriptions": {
                              "typeIdentifier": "t_magic_message",
                              "typeString": "msg"
                            }
                          },
                          "id": 31977,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "sender",
                          "nodeType": "MemberAccess",
                          "src": "816:10:77",
                          "typeDescriptions": {
                            "typeIdentifier": "t_address",
                            "typeString": "address"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "==",
                        "rightExpression": {
                          "id": 31978,
                          "name": "_owner",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 4130,
                          "src": "830:6:77",
                          "typeDescriptions": {
                            "typeIdentifier": "t_address",
                            "typeString": "address"
                          }
                        },
                        "src": "816:20:77",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "4f4e4c595f4f574e4552",
                        "id": 31980,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "838:12:77",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_ed52dd835ef8b4a2cee9a7c6acf4a6ded47de936e18191957aa373d7aa16dbef",
                          "typeString": "literal_string \"ONLY_OWNER\""
                        },
                        "value": "ONLY_OWNER"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_ed52dd835ef8b4a2cee9a7c6acf4a6ded47de936e18191957aa373d7aa16dbef",
                          "typeString": "literal_string \"ONLY_OWNER\""
                        }
                      ],
                      "id": 31975,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        -18,
                        -18
                      ],
                      "referencedDeclaration": -18,
                      "src": "808:7:77",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 31981,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "808:43:77",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 31982,
                  "nodeType": "ExpressionStatement",
                  "src": "808:43:77"
                },
                {
                  "assignments": [
                    31984,
                    31986,
                    31988
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 31984,
                      "mutability": "mutable",
                      "name": "componentId",
                      "nameLocation": "866:11:77",
                      "nodeType": "VariableDeclaration",
                      "scope": 32031,
                      "src": "858:19:77",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      },
                      "typeName": {
                        "id": 31983,
                        "name": "uint256",
                        "nodeType": "ElementaryTypeName",
                        "src": "858:7:77",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "visibility": "internal"
                    },
                    {
                      "constant": false,
                      "id": 31986,
                      "mutability": "mutable",
                      "name": "entity",
                      "nameLocation": "887:6:77",
                      "nodeType": "VariableDeclaration",
                      "scope": 32031,
                      "src": "879:14:77",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      },
                      "typeName": {
                        "id": 31985,
                        "name": "uint256",
                        "nodeType": "ElementaryTypeName",
                        "src": "879:7:77",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "visibility": "internal"
                    },
                    {
                      "constant": false,
                      "id": 31988,
                      "mutability": "mutable",
                      "name": "value",
                      "nameLocation": "908:5:77",
                      "nodeType": "VariableDeclaration",
                      "scope": 32031,
                      "src": "895:18:77",
                      "stateVariable": false,
                      "storageLocation": "memory",
                      "typeDescriptions": {
                        "typeIdentifier": "t_bytes_memory_ptr",
                        "typeString": "bytes"
                      },
                      "typeName": {
                        "id": 31987,
                        "name": "bytes",
                        "nodeType": "ElementaryTypeName",
                        "src": "895:5:77",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bytes_storage_ptr",
                          "typeString": "bytes"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 32000,
                  "initialValue": {
                    "arguments": [
                      {
                        "id": 31991,
                        "name": "arguments",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 31970,
                        "src": "928:9:77",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bytes_memory_ptr",
                          "typeString": "bytes memory"
                        }
                      },
                      {
                        "components": [
                          {
                            "id": 31993,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": true,
                            "lValueRequested": false,
                            "nodeType": "ElementaryTypeNameExpression",
                            "src": "940:7:77",
                            "typeDescriptions": {
                              "typeIdentifier": "t_type$_t_uint256_$",
                              "typeString": "type(uint256)"
                            },
                            "typeName": {
                              "id": 31992,
                              "name": "uint256",
                              "nodeType": "ElementaryTypeName",
                              "src": "940:7:77",
                              "typeDescriptions": {}
                            }
                          },
                          {
                            "id": 31995,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": true,
                            "lValueRequested": false,
                            "nodeType": "ElementaryTypeNameExpression",
                            "src": "949:7:77",
                            "typeDescriptions": {
                              "typeIdentifier": "t_type$_t_uint256_$",
                              "typeString": "type(uint256)"
                            },
                            "typeName": {
                              "id": 31994,
                              "name": "uint256",
                              "nodeType": "ElementaryTypeName",
                              "src": "949:7:77",
                              "typeDescriptions": {}
                            }
                          },
                          {
                            "id": 31997,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": true,
                            "lValueRequested": false,
                            "nodeType": "ElementaryTypeNameExpression",
                            "src": "958:5:77",
                            "typeDescriptions": {
                              "typeIdentifier": "t_type$_t_bytes_storage_ptr_$",
                              "typeString": "type(bytes storage pointer)"
                            },
                            "typeName": {
                              "id": 31996,
                              "name": "bytes",
                              "nodeType": "ElementaryTypeName",
                              "src": "958:5:77",
                              "typeDescriptions": {}
                            }
                          }
                        ],
                        "id": 31998,
                        "isConstant": false,
                        "isInlineArray": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "nodeType": "TupleExpression",
                        "src": "939:25:77",
                        "typeDescriptions": {
                          "typeIdentifier": "t_tuple$_t_type$_t_uint256_$_$_t_type$_t_uint256_$_$_t_type$_t_bytes_storage_ptr_$_$",
                          "typeString": "tuple(type(uint256),type(uint256),type(bytes storage pointer))"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bytes_memory_ptr",
                          "typeString": "bytes memory"
                        },
                        {
                          "typeIdentifier": "t_tuple$_t_type$_t_uint256_$_$_t_type$_t_uint256_$_$_t_type$_t_bytes_storage_ptr_$_$",
                          "typeString": "tuple(type(uint256),type(uint256),type(bytes storage pointer))"
                        }
                      ],
                      "expression": {
                        "id": 31989,
                        "name": "abi",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": -1,
                        "src": "917:3:77",
                        "typeDescriptions": {
                          "typeIdentifier": "t_magic_abi",
                          "typeString": "abi"
                        }
                      },
                      "id": 31990,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "lValueRequested": false,
                      "memberName": "decode",
                      "nodeType": "MemberAccess",
                      "src": "917:10:77",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_abidecode_pure$__$returns$__$",
                        "typeString": "function () pure"
                      }
                    },
                    "id": 31999,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "917:48:77",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$_t_uint256_$_t_uint256_$_t_bytes_memory_ptr_$",
                      "typeString": "tuple(uint256,uint256,bytes memory)"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "857:108:77"
                },
                {
                  "assignments": [
                    32003
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 32003,
                      "mutability": "mutable",
                      "name": "c",
                      "nameLocation": "982:1:77",
                      "nodeType": "VariableDeclaration",
                      "scope": 32031,
                      "src": "971:12:77",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_contract$_IComponent_$4941",
                        "typeString": "contract IComponent"
                      },
                      "typeName": {
                        "id": 32002,
                        "nodeType": "UserDefinedTypeName",
                        "pathNode": {
                          "id": 32001,
                          "name": "IComponent",
                          "nodeType": "IdentifierPath",
                          "referencedDeclaration": 4941,
                          "src": "971:10:77"
                        },
                        "referencedDeclaration": 4941,
                        "src": "971:10:77",
                        "typeDescriptions": {
                          "typeIdentifier": "t_contract$_IComponent_$4941",
                          "typeString": "contract IComponent"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 32010,
                  "initialValue": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "id": 32006,
                            "name": "components",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 4125,
                            "src": "1012:10:77",
                            "typeDescriptions": {
                              "typeIdentifier": "t_contract$_IUint256Component_$4983",
                              "typeString": "contract IUint256Component"
                            }
                          },
                          {
                            "id": 32007,
                            "name": "componentId",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 31984,
                            "src": "1024:11:77",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          }
                        ],
                        "expression": {
                          "argumentTypes": [
                            {
                              "typeIdentifier": "t_contract$_IUint256Component_$4983",
                              "typeString": "contract IUint256Component"
                            },
                            {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          ],
                          "id": 32005,
                          "name": "getAddressById",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 5176,
                          "src": "997:14:77",
                          "typeDescriptions": {
                            "typeIdentifier": "t_function_internal_view$_t_contract$_IUint256Component_$4983_$_t_uint256_$returns$_t_address_$",
                            "typeString": "function (contract IUint256Component,uint256) view returns (address)"
                          }
                        },
                        "id": 32008,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "kind": "functionCall",
                        "lValueRequested": false,
                        "names": [],
                        "nodeType": "FunctionCall",
                        "src": "997:39:77",
                        "tryCall": false,
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      ],
                      "id": 32004,
                      "name": "IComponent",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 4941,
                      "src": "986:10:77",
                      "typeDescriptions": {
                        "typeIdentifier": "t_type$_t_contract$_IComponent_$4941_$",
                        "typeString": "type(contract IComponent)"
                      }
                    },
                    "id": 32009,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "typeConversion",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "986:51:77",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_contract$_IComponent_$4941",
                      "typeString": "contract IComponent"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "971:66:77"
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 32014,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "expression": {
                        "id": 32011,
                        "name": "value",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 31988,
                        "src": "1047:5:77",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bytes_memory_ptr",
                          "typeString": "bytes memory"
                        }
                      },
                      "id": 32012,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "length",
                      "nodeType": "MemberAccess",
                      "src": "1047:12:77",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "hexValue": "30",
                      "id": 32013,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "1063:1:77",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_0_by_1",
                        "typeString": "int_const 0"
                      },
                      "value": "0"
                    },
                    "src": "1047:17:77",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "falseBody": {
                    "id": 32029,
                    "nodeType": "Block",
                    "src": "1103:35:77",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "id": 32025,
                              "name": "entity",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 31986,
                              "src": "1117:6:77",
                              "typeDescriptions": {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            },
                            {
                              "id": 32026,
                              "name": "value",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 31988,
                              "src": "1125:5:77",
                              "typeDescriptions": {
                                "typeIdentifier": "t_bytes_memory_ptr",
                                "typeString": "bytes memory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              },
                              {
                                "typeIdentifier": "t_bytes_memory_ptr",
                                "typeString": "bytes memory"
                              }
                            ],
                            "expression": {
                              "id": 32022,
                              "name": "c",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 32003,
                              "src": "1111:1:77",
                              "typeDescriptions": {
                                "typeIdentifier": "t_contract$_IComponent_$4941",
                                "typeString": "contract IComponent"
                              }
                            },
                            "id": 32024,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "set",
                            "nodeType": "MemberAccess",
                            "referencedDeclaration": 4887,
                            "src": "1111:5:77",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_external_nonpayable$_t_uint256_$_t_bytes_memory_ptr_$returns$__$",
                              "typeString": "function (uint256,bytes memory) external"
                            }
                          },
                          "id": 32027,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "1111:20:77",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_tuple$__$",
                            "typeString": "tuple()"
                          }
                        },
                        "id": 32028,
                        "nodeType": "ExpressionStatement",
                        "src": "1111:20:77"
                      }
                    ]
                  },
                  "id": 32030,
                  "nodeType": "IfStatement",
                  "src": "1043:95:77",
                  "trueBody": {
                    "id": 32021,
                    "nodeType": "Block",
                    "src": "1066:31:77",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "id": 32018,
                              "name": "entity",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 31986,
                              "src": "1083:6:77",
                              "typeDescriptions": {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            ],
                            "expression": {
                              "id": 32015,
                              "name": "c",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 32003,
                              "src": "1074:1:77",
                              "typeDescriptions": {
                                "typeIdentifier": "t_contract$_IComponent_$4941",
                                "typeString": "contract IComponent"
                              }
                            },
                            "id": 32017,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "remove",
                            "nodeType": "MemberAccess",
                            "referencedDeclaration": 4892,
                            "src": "1074:8:77",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_external_nonpayable$_t_uint256_$returns$__$",
                              "typeString": "function (uint256) external"
                            }
                          },
                          "id": 32019,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "1074:16:77",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_tuple$__$",
                            "typeString": "tuple()"
                          }
                        },
                        "id": 32020,
                        "nodeType": "ExpressionStatement",
                        "src": "1074:16:77"
                      }
                    ]
                  }
                }
              ]
            },
            "baseFunctions": [
              4953
            ],
            "functionSelector": "09c5eabe",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "execute",
            "nameLocation": "740:7:77",
            "parameters": {
              "id": 31971,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 31970,
                  "mutability": "mutable",
                  "name": "arguments",
                  "nameLocation": "761:9:77",
                  "nodeType": "VariableDeclaration",
                  "scope": 32032,
                  "src": "748:22:77",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_bytes_memory_ptr",
                    "typeString": "bytes"
                  },
                  "typeName": {
                    "id": 31969,
                    "name": "bytes",
                    "nodeType": "ElementaryTypeName",
                    "src": "748:5:77",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bytes_storage_ptr",
                      "typeString": "bytes"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "747:24:77"
            },
            "returnParameters": {
              "id": 31974,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 31973,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 32032,
                  "src": "788:12:77",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_bytes_memory_ptr",
                    "typeString": "bytes"
                  },
                  "typeName": {
                    "id": 31972,
                    "name": "bytes",
                    "nodeType": "ElementaryTypeName",
                    "src": "788:5:77",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bytes_storage_ptr",
                      "typeString": "bytes"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "787:14:77"
            },
            "scope": 32054,
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "id": 32053,
            "nodeType": "FunctionDefinition",
            "src": "1146:241:77",
            "nodes": [],
            "body": {
              "id": 32052,
              "nodeType": "Block",
              "src": "1322:65:77",
              "nodes": [],
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "id": 32046,
                            "name": "componentId",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 32034,
                            "src": "1354:11:77",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          {
                            "id": 32047,
                            "name": "entity",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 32036,
                            "src": "1367:6:77",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          {
                            "id": 32048,
                            "name": "value",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 32038,
                            "src": "1375:5:77",
                            "typeDescriptions": {
                              "typeIdentifier": "t_bytes_memory_ptr",
                              "typeString": "bytes memory"
                            }
                          }
                        ],
                        "expression": {
                          "argumentTypes": [
                            {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            },
                            {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            },
                            {
                              "typeIdentifier": "t_bytes_memory_ptr",
                              "typeString": "bytes memory"
                            }
                          ],
                          "expression": {
                            "id": 32044,
                            "name": "abi",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": -1,
                            "src": "1343:3:77",
                            "typeDescriptions": {
                              "typeIdentifier": "t_magic_abi",
                              "typeString": "abi"
                            }
                          },
                          "id": 32045,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "lValueRequested": false,
                          "memberName": "encode",
                          "nodeType": "MemberAccess",
                          "src": "1343:10:77",
                          "typeDescriptions": {
                            "typeIdentifier": "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                            "typeString": "function () pure returns (bytes memory)"
                          }
                        },
                        "id": 32049,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "kind": "functionCall",
                        "lValueRequested": false,
                        "names": [],
                        "nodeType": "FunctionCall",
                        "src": "1343:38:77",
                        "tryCall": false,
                        "typeDescriptions": {
                          "typeIdentifier": "t_bytes_memory_ptr",
                          "typeString": "bytes memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bytes_memory_ptr",
                          "typeString": "bytes memory"
                        }
                      ],
                      "id": 32043,
                      "name": "execute",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 32032,
                      "src": "1335:7:77",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_nonpayable$_t_bytes_memory_ptr_$returns$_t_bytes_memory_ptr_$",
                        "typeString": "function (bytes memory) returns (bytes memory)"
                      }
                    },
                    "id": 32050,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1335:47:77",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_bytes_memory_ptr",
                      "typeString": "bytes memory"
                    }
                  },
                  "functionReturnParameters": 32042,
                  "id": 32051,
                  "nodeType": "Return",
                  "src": "1328:54:77"
                }
              ]
            },
            "functionSelector": "34830fd7",
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "executeTyped",
            "nameLocation": "1155:12:77",
            "parameters": {
              "id": 32039,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 32034,
                  "mutability": "mutable",
                  "name": "componentId",
                  "nameLocation": "1181:11:77",
                  "nodeType": "VariableDeclaration",
                  "scope": 32053,
                  "src": "1173:19:77",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 32033,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "1173:7:77",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 32036,
                  "mutability": "mutable",
                  "name": "entity",
                  "nameLocation": "1206:6:77",
                  "nodeType": "VariableDeclaration",
                  "scope": 32053,
                  "src": "1198:14:77",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 32035,
                    "name": "uint256",
                    "nodeType": "ElementaryTypeName",
                    "src": "1198:7:77",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 32038,
                  "mutability": "mutable",
                  "name": "value",
                  "nameLocation": "1231:5:77",
                  "nodeType": "VariableDeclaration",
                  "scope": 32053,
                  "src": "1218:18:77",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_bytes_memory_ptr",
                    "typeString": "bytes"
                  },
                  "typeName": {
                    "id": 32037,
                    "name": "bytes",
                    "nodeType": "ElementaryTypeName",
                    "src": "1218:5:77",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bytes_storage_ptr",
                      "typeString": "bytes"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "1167:124:77"
            },
            "returnParameters": {
              "id": 32042,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 32041,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 32053,
                  "src": "1308:12:77",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_bytes_memory_ptr",
                    "typeString": "bytes"
                  },
                  "typeName": {
                    "id": 32040,
                    "name": "bytes",
                    "nodeType": "ElementaryTypeName",
                    "src": "1308:5:77",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bytes_storage_ptr",
                      "typeString": "bytes"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "1307:14:77"
            },
            "scope": 32054,
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          }
        ],
        "abstract": false,
        "baseContracts": [
          {
            "baseName": {
              "id": 31946,
              "name": "System",
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 4204,
              "src": "439:6:77"
            },
            "id": 31947,
            "nodeType": "InheritanceSpecifier",
            "src": "439:6:77"
          }
        ],
        "canonicalName": "ComponentDevSystem",
        "contractDependencies": [],
        "contractKind": "contract",
        "fullyImplemented": true,
        "linearizedBaseContracts": [
          32054,
          4204,
          4954,
          39813
        ],
        "name": "ComponentDevSystem",
        "nameLocation": "417:18:77",
        "scope": 32055,
        "usedErrors": []
      }
    ],
    "license": "GPL-3.0"
  },
  "id": 77
}